import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startReport107106Status: 'idle',
    startReport107106Error: undefined as any,
    loadUserParamsReport107106Status: 'idle',
    loadUserParamsReport107106Error: undefined as any,

    report107106List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startReport107106 = createAsyncThunk('report107106Slice/startReport107106', async ({ report107106 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartReport107106/`,
        prepareData(report107106),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startReport107106Status } = getState().report107106Slice
        return startReport107106Status !== 'pending'
    }
})

export const loadUserParamsReport107106 = createAsyncThunk('report107106Slice/loadUserParamsReport107106', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsReport107106/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsReport107106Status } = getState().report107106Slice
        return loadUserParamsReport107106Status !== 'pending'
    }
})

const Report107106Slice = createSlice({
    name: 'report107106Slice',
    initialState,
    reducers: {
        resetstartReport107106: (state) => {
            state.job = undefined
            state.startReport107106Error = undefined
        },
        resetstartReport107106Error: (state) => {
            state.startReport107106Error = undefined
        },
        resetloadUserParamsReport107106: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsReport107106Error = undefined
        },
        resetloadUserParamsReport107106Error: (state) => {
            state.loadUserParamsReport107106Error = undefined
        },
        removeFromReport107106ListById: (state, action) => {
            state.report107106List = state.report107106List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromReport107106ListByIds: (state, action) => {
            state.report107106List = state.report107106List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.report107106List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startReport107106Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.report107106List = []
            state.startReport107106Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startReport107106.pending, (state) => {
            state.startReport107106Status = 'pending'
            state.startReport107106Error = undefined
        })
        builder.addCase(startReport107106.fulfilled, (state, action) => {
            state.startReport107106Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startReport107106.rejected, (state, action) => {
            state.startReport107106Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startReport107106Error = action.error.message
            } else {
                state.startReport107106Error = action.payload
            }
        })

        builder.addCase(loadUserParamsReport107106.pending, (state) => {
            state.loadUserParamsReport107106Status = 'pending'
            state.loadUserParamsReport107106Error = undefined
        })
        builder.addCase(loadUserParamsReport107106.fulfilled, (state, action) => {
            state.loadUserParamsReport107106Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsReport107106.rejected, (state, action) => {
            state.loadUserParamsReport107106Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsReport107106Error = action.error.message
            } else {
                state.loadUserParamsReport107106Error = action.payload
            }
        })

    }
})

export const {
    resetstartReport107106,
    resetstartReport107106Error,
    resetloadUserParamsReport107106,
    resetloadUserParamsReport107106Error,
    removeFromReport107106ListById,
    removeFromReport107106ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Report107106Slice.actions
export default Report107106Slice.reducer
